__turbopack_context__.v({
  "List": "Qv75iq_List",
  "Root": "Qv75iq_Root",
  "Root--Column": "Qv75iq_Root--Column",
  "skeleton-loading": "Qv75iq_skeleton-loading",
});
